// @flow

import * as React from "react";
import SVG from "react-inlinesvg";

import Card from "../Card";

import styles from "./SummaryCard.scss";

type SummaryCardProps = {
  title: string,
  children: React.Node,
  icon: {
    src: string,
    alt: string
  }
};

const SummaryCard = ({ children, icon, title }: SummaryCardProps) => (
  <Card additionalCardStyles={styles.summaryCard}>
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      {children}
    </div>
    <div className={styles.iconWrapper}>
      <SVG className={styles.icon} src={icon.src} alt={icon.alt} />
    </div>
  </Card>
);

SummaryCard.defaultProps = {
  title: "",
  image: null
};

export default SummaryCard;
